import React, { useEffect, useState } from "react";
import "../Zone/Zone.css";
import "../Overview/Overview.css";
import { fetchEmployees } from "../../Services/locationEntries";

function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

function initials(name) {
  if (!name) return "?";
  return name.slice(0, 2).toUpperCase();
}

function HomeWorkforce({ className, onBack, onEmployeeClick, allowedLocationIds }) {
  const [employees, setEmployees] = useState(null);

  useEffect(() => {
    setEmployees(null);
    fetchEmployees(allowedLocationIds)
      .then((list) => setEmployees(list.sort((a, b) => (a.name || "").localeCompare(b.name || ""))))
      .catch(() => setEmployees([]));
  }, [allowedLocationIds]);

  return (
    <div className={className} data-cy="home-workforce-screen">
      <div className="subhdr">
        <div className="back" onClick={onBack}>
          <svg viewBox="0 0 24 24">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </div>
        <div className="subhdr-info">
          <div className="subhdr-crumb">Chennai · All PCTs</div>
          <div className="subhdr-title">Workforce</div>
        </div>
        {employees && <span className="pill neutral">{employees.length}</span>}
      </div>
      <div className="divider" />
      <div className="scroll">
        {employees === null && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>Loading…</div>
        )}
        {employees?.length === 0 && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>No employees found.</div>
        )}
        {employees?.length > 0 && (
          <div className="lrows">
            {employees.map((emp) => {
              const contact = emp.phoneNumber || emp.email || "—";
              const lastAt = emp.captureStatus?.lastCapturedAt;
              const lastIn = emp.captureStatus?.location?.PCTNo
                ? `PCT-${emp.captureStatus.location.PCTNo}`
                : null;
              return (
                <div
                  key={emp.documentId}
                  className="lrow"
                  onClick={() => onEmployeeClick && onEmployeeClick(emp)}
                  data-cy={`employee-row-${emp.documentId}`}
                >
                  <div className="licon">{initials(emp.name)}</div>
                  <div className="li">
                    <div className="ln">{emp.name || "—"}</div>
                    <div className="ls">{contact}</div>
                  </div>
                  <div className="lr" style={{ maxWidth: "80px" }}>
                    <div className="lpct">{fmtDate(lastAt)}</div>
                    <div className="ll">last capture</div>
                    {lastIn && <div style={{ fontSize: "var(--text-xs)", color: "var(--t3)", marginTop: "2px", fontFamily: "var(--font-mono)" }}>{lastIn}</div>}
                  </div>
                  <div className="chevron">
                    <svg viewBox="0 0 24 24">
                      <polyline points="9,18 15,12 9,6" />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div style={{ height: "20px" }} />
      </div>
    </div>
  );
}

export default HomeWorkforce;
